import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import appTranslations from "../../sc-translate/appTranslations";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(1),
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});
export const languages = (translations) => {
    return [{ value: 'en', displayValue: translations['english'] || 'English' },
    { value: 'de', displayValue: translations['german'] || 'German' }
    ];
}

const OrderForm = props => {
    const { classes, formSettings, statuses, create, types, initialValues, loading, handleSubmit, clientInformation, translations, reportInformation, filePatterns, groups } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, setFieldValue, handleSubmit } = formikProps;

                    const clientID = clientInformation && clientInformation.length > 0;
                    const projectID = (clientInformation ? clientInformation : []).map(el => el.Projects).length > 0;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="Description"
                                value={values.Description || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations["description"] || "Description"}
                                label={translations["description"] || "Description"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["clients_text"] || "Please select client"}</InputLabel>
                                <Select
                                    name="ClientID"
                                    label={translations["client_information"] || "Client information"}
                                    margin={"dense"}
                                    value={clientID ? values.ClientID : ""}
                                    onChange={(event) => { setFieldValue('ProjectID', ''); handleChange(event) }}
                                >
                                    {(clientInformation ? [...clientInformation] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["project_text"] || "Please select project"}</InputLabel>
                                <Select
                                    name="ProjectID"
                                    label={translations["project_information"] || "Project information"}
                                    margin={"dense"}
                                    value={projectID ? values.ProjectID : ''}
                                    onChange={handleChange}
                                >
                                    {(clientInformation?.length > 0 ? [...clientInformation].filter(client => client.value === values.ClientID) : []).map(
                                        client => {
                                            return client?.Projects.map(option => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.displayValue}
                                                </MenuItem>
                                            ))
                                        }
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["status_text"] || "Please select status"}</InputLabel>
                                <Select
                                    name="Status"
                                    label={translations["status_information"] || "Status information"}
                                    margin={"dense"}
                                    value={values.Status || ""}
                                    onChange={handleChange}
                                >
                                    {(statuses ? [...statuses] : []).map(option => (
                                        <MenuItem key={option.value + 'key'} value={option.value}>
                                            {translations[option.value] || option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["type_text"] || "Please select type"}</InputLabel>
                                <Select
                                    name="Type"
                                    label={translations["type_information"] || "Type information"}
                                    margin={"dense"}
                                    value={values.Type || ""}
                                    onChange={handleChange}
                                >
                                    {(types ? [...types] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {translations[option.value] || option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["report_information_text"] || "Please select report information"}</InputLabel>
                                <Select
                                    name="ReportDataID"
                                    label={translations["report_information"] || "Report information"}
                                    margin={"dense"}
                                    value={values.ReportDataID || ""}
                                    onChange={handleChange}
                                >
                                    {(reportInformation ? [...reportInformation] : []).map(option => (
                                        <MenuItem key={option.value + 'key'} value={option.value} >
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["file_pattern_text"] || "Please select file pattern"}</InputLabel>

                                <Select
                                    name="FilePatternID"
                                    label={translations["file_pattern"] || "File pattern"}
                                    margin={"dense"}
                                    value={values.FilePatternID || ""}
                                    onChange={handleChange}
                                >
                                    {(filePatterns ? [...filePatterns] : []).map(option => (
                                        <MenuItem key={option.value} value={option?.value?.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["please_select_langue"] || "Please select language"}</InputLabel>
                                <Select
                                    name="DefaultLanguage"
                                    label={translations["langue"] || "Language"}
                                    margin={"dense"}
                                    value={values.DefaultLanguage || ""}
                                    onChange={handleChange}
                                >
                                    {appTranslations.map(option => (
                                        <MenuItem key={option.code} value={option.code}>
                                            {option.displayName} - {translations[option.displayName.toLowerCase()] || option.displayName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            margin={"dense"}
                                            name={"ErasureReportSignature"}
                                            checked={values.ErasureReportSignature}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={translations["erasure_report_signature"] || "Erasure report signature"}
                                />
                            </FormGroup>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["group"] || "Group"}</InputLabel>
                                <Select
                                    name="GroupID"
                                    label={translations["group"] || "Group"}
                                    margin={"dense"}
                                    value={values.GroupID}
                                    onChange={handleChange}
                                >
                                    {(groups ? [...groups] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div className={classes.buttons}>
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}

                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        style={{ width: '100%' }}
                                        type="submit"
                                        disabled={!(isValid && dirty) || isSubmitting}
                                    >
                                        {!create ? formSettings.ButtonSubmit.Title
                                            : isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div >
    );
};

export default withStyles(styles, { withTheme: true })(OrderForm);
